﻿<script>
  import Link from "../../NavLink.svelte";
  import { navigate } from "svelte-routing";
  import Navbar from "../Navbar.svelte";
  import { Spinner } from "sveltestrap";
  import { onMount } from "svelte";
  import JobBoard from "./JobBoard.svelte";
  import axios from "axios";
  import { getMsalInstance } from "../../msal-config.js";

  let msalInstance = null;

  let email = "";
  let password = "";
  let error = false;
  let logging = false;
  let teams;
  let errorMessage = 'Login credentials are incorrect';

  let userLoginMode = 'default'; // default | mfa
  let msalLoginMethod = 'redirect'; // redirect | popup

  onMount(async () => {
    localStorage.setItem("collapse", false);

    switch (window.appSettings.userLoginMode) {
      case "mfa":
        userLoginMode = 'mfa';
        msalLoginMethod = 'redirect';
        break;
      default:
        userLoginMode = 'default';
        msalLoginMethod = 'popup';
        break;
    }

    await initializeMFA();
    if (userLoginMode === 'mfa' && msalLoginMethod === 'redirect') {
      handleLoginWithMFA();
    }
  });

  async function initializeMFA() {
    msalInstance = await getMsalInstance();
    await msalInstance.initialize();
  }

  async function loginUser() {
    const data = {
      username: email,
      password: password
    };

    await processLogin("/authentication/login", data);
  }

  async function loginUserFromMFA(account, accessToken) {
    logging = true;
    const data = {
      username: account.username,
      password: accessToken,
    };

    await processLogin("/authentication/loginmfa", data);
    logging = false;
  }

  async function processLogin(url, data) {
    const rawResponse = await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(data)
    }).finally(_ => logging = false);
    const json = await rawResponse.json();
    if (json.StatusCode === 200) {
      navigate("timesheet" + window.location.search, { replace: true });
      document.title = "Timesheet";
      localStorage.setItem("timecardcollapse", false);
    } else {
      error = true;
      errorMessage = 'Login credentials are incorrect';
      console.error(json.Message);
    }
  }

  function checkIsAdmin() {
    fetch(`/authentication/isadmin`)
      .then(response => response.json())
      .then(response => {
        const isAdmin = response.Result;
        sessionStorage.setItem('is_admin', isAdmin);
      });
  }

  function handleLogin() {
    if (email === "" || password === "") {
      error = true;
    } else {
      logging = true;
      error = false;
      loginUser().then(_ => {
        if (!error) {
          checkIsAdmin();
        }
      });
    }
  }

  function handleLoginWithMFA() {
    if (msalLoginMethod === 'redirect') {
      const isFromMFARedirection = window.location.hash.includes('code');
      if (msalInstance.getAllAccounts().length <= 0 && !isFromMFARedirection) {
        msalInstance.loginRedirect()
          .then(handleMFAResponse)
          .catch(error => {
            logging = false;
            console.error(error);
          });
      } else {
        msalInstance.handleRedirectPromise()
        .then(handleMFAResponse)
        .catch(error => {
          logging = false;
          console.error(error);
        });
      }
    } else {
      msalInstance.loginPopup()
        .then(handleMFAResponse)
        .catch(error => {
          logging = false;
          console.error(error);
        });
    }
  }

  async function handleMFAResponse(response) {
    if (response !== null) {
      await loginUserFromMFA(response.account, response.accessToken);
      return;
    }

    const currentAccounts = msalInstance.getAllAccounts();
    if (!currentAccounts || currentAccounts.length < 1) {
      handleLoginWithMFA();
      return;
    } else if (currentAccounts.length > 1) {
      console.warn("Multiple accounts detected.", currentAccounts);

      handleLoginWithMFA();
    } else if (currentAccounts.length === 1) {
      const account = currentAccounts[0];

      await loginUserFromMFA(account, account.idToken);
    }
  }
</script>

<style>
  .main-login {
    padding: 1em;
    margin: 0 auto;
    height: 100%;
    text-align: center;
    width: 30%;
    color: #4e575a;
  }

  input {
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
    background-color: white;
  }
  label {
    margin-left: 5px;
  }
  .login-container {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #b2bec3;
  }
  .login-form {
    padding: 20px;
    text-align: left;
  }
  .login-form-title {
    border-bottom: 1px solid #b2bec3;
    padding: 10px 0;
    background-color: #dcdde1;
    border-radius: 5px 5px 0px 0px;
  }
  @media (max-width: 1024px) {
    .main-login {
      width: 40%;
    }
  }

  @media (max-width: 768px) {
    .main-login {
      width: 60%;
    }
  }

  @media (max-width: 425px) {
    main {
      width: 80%;
    }
    .main-login {
      padding: 0px;
      width: 90%;
      margin-bottom: 30px;
    }
  }

  button {
    width: 35%;
    border-radius: 30px;
    color: #0984e3;
    background-color: white;
    font-weight: bold;
    border: none;
    margin-top: 10px;
    padding: 8px 0px;
    border: 1px solid #0984e3;
    transition: color 0.3s, background-color 0.3s;
    text-decoration: none;
  }

  button:hover {
    color: white;
    background-color: #0984e3;
  }
  .error-login-container {
    width: 100%;
    background-color: #fab1a0;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    margin-top: 1em;
  }
  .disable {
    cursor: not-allowed;
    opacity: 0.5;
  }
  @media (max-width: 375px) {
    button {
      width: 50%;
    }
  }

  .btn-login {
    display: flex;
    gap: 1rem;
  }
</style>

<Navbar/>
<main class="main-login">
  {#if error}
    <div class="error-login-container">
      {errorMessage}
    </div>
  {/if}
  {#if userLoginMode === 'default'}
    <div class="login-container">
      <div class="login-form-title">Enter Your Credentials</div>
      <div class="login-form">
        <form on:submit|preventDefault={handleLogin}>
          <label>Email</label>
          <div class="input-email">
            <input type="email" bind:value={email} />
          </div>
          <label>Password</label>
          <div class="input-password">
            <input type="password" bind:value={password} />
          </div>
          <div class="btn-login">
            {#if logging}
              <button type="submit" class="disable" disabled={true}>
                <Spinner size="sm" />
                Logging in
              </button>
            {:else}
              <button type="submit">Login</button>
              <button type="button" on:click={handleLoginWithMFA}>MFA Login</button>
            {/if}
          </div>
        </form>
      </div>
    </div>
  {/if}
  {#if userLoginMode === 'mfa' && !error}
    <p>Logging in...</p>
  {/if}
</main>
